var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-tab-container",class:{
        'official-joined': _vm.$root.officialJoinedStyle,
    },style:({
        backgroundColor: _vm.$root.officialBackgroundColor,
    })},[_c('div',{ref:"tab",staticClass:"tab-wrapper scroll-x"},_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:index,class:['tab-item', _vm.$root.tabIndex === index ? 'tab-item-focus' : ''],style:({
                color: _vm.$root.tabIndex === index ?
                    _vm.$root.officialHighLightFontColor : _vm.$root.officialNormalFontColor,
            }),on:{"click":function($event){return _vm.changeTab(index)}}},[_c('span',[_vm._v(_vm._s(tab))]),(_vm.$root.tabIndex === index)?_c('div',{staticClass:"tab-item-line",style:({
                    borderColor: _vm.$root.officialHighLightFontColor,
                })}):_vm._e()])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }